import { ofType } from 'redux-observable';
import {
  catchError,
  map,
  switchMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, from, of, concat, defer } from 'rxjs';
import { httpMethods, request } from '../../../../../services/http-service';
import { RETRIEVE_PRATICA } from '../../data.const';
import {
  setCurrentPraticaAction,
  setLoaders,
  setPopupInfo,
} from '../../data.action';

const retrievePraticaEpic = (action$: any, state$: any) =>
  action$.pipe(
    ofType(RETRIEVE_PRATICA),
    map(({ payload }: any) => payload),
    // tap(p => console.log(`[epic ${RETRIEVE_PRATICA}]`, p)),
    withLatestFrom(state$),
    switchMap(([id, _state]) => {
      return concat(
        of(setLoaders({ praticaLoader: true })),
        defer(() =>
          from(
            request({ path: `pratica/${id}`, method: httpMethods.GET })
          ).pipe(
            map((p: any) => {
              if (p?.status > 299) {
                throw new Error('Server error');
              }
              return p?.result;
            }),
            // tap(p => console.log(`[epic ${RETRIEVE_PRATICA}]`, p)),
            // switchMap(() => EMPTY),
            switchMap(p => of(setCurrentPraticaAction(p))),
            catchError(err => {
              console.error(`[epic ${RETRIEVE_PRATICA}] error`, err);
              return EMPTY;
            })
          )
        ),
        of(setLoaders({ praticaLoader: false }))
      );
    })
  );

export default retrievePraticaEpic;
